/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



/* === FX: ocultar el chat (Shopify Inbox) mientras el mini-carrito esta abierto === */
(function () {
  function chatHosts() {
    var hosts = [];
    var add = function (e) { if (e && hosts.indexOf(e) === -1) hosts.push(e); };
    /* 1) ids/clases conocidos */
    document.querySelectorAll('#shopify-chat, #ShopifyChat, [id^="shopify-chat"], [id^="ShopifyChat"], [class*="shopify-chat"]').forEach(add);
    /* 2) custom elements de chat colgados del body (cubre shadow DOM: ocultar el host oculta su interior) */
    Array.prototype.forEach.call(document.body.children, function (el) {
      var t = el.tagName || '';
      if (t.indexOf('-') !== -1 && /CHAT|INBOX/i.test(t)) add(el);
    });
    /* 3) iframes de chat en el DOM normal */
    document.querySelectorAll('iframe').forEach(function (f) {
      var firma = (f.src || '') + ' ' + (f.title || '') + ' ' + (f.id || '') + ' ' + (f.className || '');
      if (/chat|inbox/i.test(firma)) {
        var host = f;
        while (host.parentElement && host.parentElement !== document.body) { host = host.parentElement; }
        add(host);
      }
    });
    /* 4) red final: hijos directos del body FIJOS pegados a la esquina inferior (donde vive el globo) */
    var mc = document.getElementById('mini-cart');
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'LINK') return;
      if (mc && (el === mc || el.contains(mc))) return;
      try {
        var cs = getComputedStyle(el);
        if (cs.position !== 'fixed') return;
        var r = el.getBoundingClientRect();
        if (r.height > 0 && r.height < 200 && r.top > window.innerHeight - 220) add(el);
      } catch (e2) {}
    });
    return hosts;
  }
  var hidden = [];
  function setHidden(hide) {
    if (hide) {
      chatHosts().forEach(function (e) {
        if (hidden.indexOf(e) === -1) hidden.push(e);
        e.style.setProperty('visibility', 'hidden', 'important');
        e.style.setProperty('pointer-events', 'none', 'important');
      });
    } else {
      hidden.forEach(function (e) {
        e.style.removeProperty('visibility');
        e.style.removeProperty('pointer-events');
      });
      hidden = [];
    }
  }
  function init() {
    var mc = document.getElementById('mini-cart');
    if (!mc) { setTimeout(init, 500); return; }
    var isOpen = function () { return mc.getAttribute('aria-hidden') === 'false' || mc.classList.contains('is-visible'); };
    var apply = function () { setHidden(isOpen()); };
    new MutationObserver(function () { apply(); if (isOpen()) { setTimeout(apply, 300); setTimeout(apply, 1000); } })
      .observe(mc, { attributes: true, attributeFilter: ['aria-hidden', 'class'] });
    document.addEventListener('product:added', function () { setTimeout(apply, 150); setTimeout(apply, 800); });
    apply();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

/* FX-CAJON-BLOQUEO:start · con el cajón abierto en escritorio, el primer clic fuera solo cierra el menú (no llega a lo de debajo) */
(function(){
  var mq = window.matchMedia('(min-width:1000px)');
  var bloquearClick = false;
  function abierto(){ var m=document.getElementById('mobile-menu'); return m && m.getAttribute('aria-hidden')==='false'; }
  function dentro(t){
    var m=document.getElementById('mobile-menu'), b=document.querySelector('.header__mobile-nav-toggle');
    return (m && m.contains(t)) || (b && b.contains(t));
  }
  window.addEventListener('pointerdown', function(e){
    if(!mq.matches || !abierto() || dentro(e.target)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    bloquearClick = true;
    var b=document.querySelector('.header__mobile-nav-toggle'); if(b) b.click();
  }, true);
  window.addEventListener('click', function(e){
    if(!bloquearClick) return;
    if(dentro(e.target)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    bloquearClick = false;
  }, true);
})();
/* FX-CAJON-BLOQUEO:end */
